var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-container" },
    [
      _c("header", { staticClass: "page-header" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c("portal-target", {
              staticClass: "d-flex align-items-center mt-1",
              attrs: { name: "sidebar-toggle" }
            }),
            _vm._v(" "),
            _c("h4", { staticClass: "mb-0" }, [_vm._v("Акты сверки")])
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          [
            _c(
              "b-button",
              {
                directives: [
                  {
                    name: "b-toggle",
                    rawName: "v-b-toggle.sidebar-fields",
                    modifiers: { "sidebar-fields": true }
                  }
                ],
                staticClass: "custom-btn-secondary mr-1",
                attrs: { id: "table-settings" }
              },
              [_c("v-icon", { attrs: { name: "buttons/cog", size: 13 } })],
              1
            ),
            _vm._v(" "),
            _c(
              "b-tooltip",
              {
                attrs: {
                  target: "table-settings",
                  triggers: "hover",
                  "custom-class": "custom-tooltip",
                  noninteractive: ""
                }
              },
              [_vm._v("\n        Колонки\n      ")]
            ),
            _vm._v(" "),
            _c(
              "b-btn",
              {
                staticClass: "custom-btn-primary",
                attrs: { disabled: _vm.isBusy },
                on: {
                  click: function($event) {
                    return _vm.onCreate()
                  }
                }
              },
              [
                _c("v-icon", { attrs: { name: "buttons/plus", size: 12 } }),
                _vm._v(" "),
                _vm.isBusy
                  ? _c("b-spinner", { attrs: { small: "" } })
                  : _vm._e(),
                _vm._v("\n        Новый акт\n      ")
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-body" },
        [
          _c(
            "div",
            { staticClass: "page-filters" },
            [
              _c("filters-drawer", {
                attrs: {
                  query: _vm.filters.query,
                  "is-busy": _vm.isBusy,
                  "hide-search-button": ""
                },
                on: {
                  "update:query": function($event) {
                    return _vm.$set(_vm.filters, "query", $event)
                  },
                  submit: _vm.onSearch
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.isBusy || (_vm.items && _vm.items.length > 0)
            ? [
                _c(
                  "div",
                  { staticClass: "page-table-container" },
                  [
                    _c("b-table", {
                      ref: "reconciliation_acts",
                      staticClass: "custom-table mb-0 text-small",
                      attrs: {
                        id: "reconciliation-acts",
                        "sticky-header": "",
                        selectable: "",
                        "select-mode": "single",
                        responsive: "",
                        busy: _vm.isBusy,
                        items: _vm.items,
                        fields: _vm.renderedFields,
                        "no-provider-filtering": "",
                        "no-provider-paging": "",
                        "no-provider-sorting": "",
                        "no-local-sorting": ""
                      },
                      on: {
                        "sort-changed": _vm.sortChanged,
                        "row-dblclicked": _vm.onRowClicked
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "table-busy",
                            fn: function() {
                              return [
                                _c("tables-skeleton", {
                                  attrs: { fields: _vm.renderedFields, rows: 4 }
                                })
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "cell(create_date)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.formatTableDate(row.item.create_date)
                                    ) +
                                    "\n          "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(period)",
                            fn: function(row) {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.formatTableDate(row.item.start_period)
                                    ) +
                                    " - " +
                                    _vm._s(
                                      _vm.formatTableDate(row.item.end_period)
                                    ) +
                                    "\n          "
                                )
                              ]
                            }
                          },
                          {
                            key: "cell(action)",
                            fn: function(row) {
                              return [
                                _c(
                                  "b-btn",
                                  {
                                    staticClass: "text-dark",
                                    attrs: { variant: "link" },
                                    on: {
                                      click: function($event) {
                                        return _vm.onEdit(row.item)
                                      }
                                    }
                                  },
                                  [
                                    _c("v-icon", {
                                      attrs: { name: "buttons/edit", size: 15 }
                                    })
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        198048583
                      )
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "page-pagination" },
                  [
                    _c("pagination-footer", {
                      attrs: {
                        "use-router": "",
                        "current-page": _vm.currentPage,
                        "total-rows": _vm.totalRows,
                        "per-page": _vm.perPage
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.currentPage = $event
                        },
                        "update:perPage": function($event) {
                          _vm.perPage = $event
                        },
                        "update:per-page": function($event) {
                          _vm.perPage = $event
                        },
                        "page-click": _vm.onPagination,
                        "per-page-change": _vm.onPerPageChange
                      }
                    })
                  ],
                  1
                )
              ]
            : _c(
                "div",
                { staticClass: "empty-state-container" },
                [
                  _c("v-icon", {
                    attrs: { name: "navbar/empty_table", size: 90 }
                  }),
                  _vm._v(" "),
                  _c("h5", [
                    _vm._v(
                      _vm._s(
                        _vm.isFiltered
                          ? "Нет данных соответствующих фильтрам."
                          : "Нет созданных актов оплаты."
                      )
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.isFiltered
                    ? _c(
                        "div",
                        [
                          _c("p", [_vm._v("Создайте новый акт прямо сейчас")]),
                          _vm._v(" "),
                          _c(
                            "b-btn",
                            {
                              staticClass: "custom-btn-primary mt-1",
                              attrs: { disabled: _vm.isBusy },
                              on: {
                                click: function($event) {
                                  return _vm.onCreate()
                                }
                              }
                            },
                            [
                              _c("v-icon", {
                                staticClass: "mr-1",
                                attrs: { name: "buttons/plus", size: 12 }
                              }),
                              _vm._v("\n          Новый акт\n        ")
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
        ],
        2
      ),
      _vm._v(" "),
      _c("DynamicTables", {
        attrs: {
          "storage-key": "reconciliationAct_columns",
          "sidebar-fields": "sidebar-fields",
          "fields-model": _vm.fields,
          fieldKey: "id"
        },
        on: {
          "update:fieldsModel": function($event) {
            _vm.fields = $event
          },
          "update:fields-model": function($event) {
            _vm.fields = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5a87508f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a87508f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReconciliationActs/ReconciliationActs.vue
// module id = null
// module chunks = 